import { z } from 'zod';
/**
 * Key formats are validated here rather than only at Stripe, so a typo comes
 * back as a field error on the input instead of an opaque upstream failure.
 * `sk_` covers both `sk_test_` and `sk_live_`; restricted keys (`rk_`) are
 * accepted too, and are the better practice for a platform integration.
 */
export const connectStripeSchema = z.object({
    secretKey: z
        .string()
        .trim()
        .min(1, 'Secret key is required')
        .refine((v) => v.startsWith('sk_') || v.startsWith('rk_'), {
        message: 'A Stripe secret key starts with sk_ or rk_',
    })
        .refine((v) => !v.startsWith('pk_'), {
        message: 'That is the publishable key. The secret key starts with sk_.',
    }),
    publishableKey: z
        .string()
        .trim()
        .min(1, 'Publishable key is required')
        .refine((v) => v.startsWith('pk_'), {
        message: 'A Stripe publishable key starts with pk_',
    }),
    /**
     * Optional on first save: a merchant cannot create the webhook endpoint in
     * Stripe until they know the URL, and they only learn the URL by saving.
     */
    webhookSecret: z
        .string()
        .trim()
        .refine((v) => v === '' || v.startsWith('whsec_'), {
        message: 'A Stripe webhook signing secret starts with whsec_',
    })
        .optional(),
});
//# sourceMappingURL=payment.js.map